export default __webpack_public_path__ + "static/media/financial-icon.11cde762.png";